import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { BlueprintAI } from "./BlueprintAI";

export const Layout = ({ children, hideFooter = false }) => (
  <div className="App min-h-screen bg-white flex flex-col">
    <Navbar />
    <main className="flex-1">{children}</main>
    {!hideFooter && <Footer />}
    <BlueprintAI />
  </div>
);
